<template>
  <RevDrawer :name="MODAL_NAMES.NEW_BATTERY" :title="i18n(translations.title)">
    <template #body>
      <StandardVsNew v-if="isStandardVsNewVariant" :brand :category-id />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './NewBatteryModal.translations'
import type { BatteryModalVariants } from './NewBatteryModal.types'
import StandardVsNew from './components/BatteryModalContent/StandardVsNew.vue'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    brand: string
    deviceName?: string
    variant?: BatteryModalVariants
    categoryId: string
  }>(),
  {
    brand: '',
    deviceName: '',
    variant: 'standard_vs_new',
  },
)

const isStandardVsNewVariant = computed(
  () => props.variant === 'standard_vs_new',
)
</script>
